// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CustomSelect from '../../components/layout/CustomSelect';
import { getAccountBalanceByClient } from '../../storage/actions/profile';
import {
  fetchWorkOrderById,
  fetchWorkOrderTemplateById,
  setCurrentTemplate,
  setCurrentWorkOrder,
} from '../../storage/actions/workOrdersActions';
import Loader from '../../components/dashboard/common/Loader';
// eslint-disable-next-line import/no-cycle
import PageHeader from '../../components/createWorkOrder/PageHeader';
import CreateWorkOrderReduxForm from '../../components/layout/reduxForm/CreateWorkOrder';
import onSubmit from '../../utils/reduxForm/onSubmit/createWorkOrder';
import getTemplatesList from '../../utils/api/get/getTemplatesList';
import { toggleModal } from '../../storage/actions/modalsActions';

const CreateAndEditWorkOrder = ({
  mainContainer,
  currentWorkOrder,
  fetchWorkOrderById,
  getAccountBalanceByClient,
  setCurrentWorkOrder,
  match,
  setCurrentTemplate,
  fetchWorkOrderTemplateById,
  toggleModal,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [isFormTouched, setFormTouched] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    const init = async () => {
      getAccountBalanceByClient();
      setCurrentTemplate({});

      const id = match?.params?.id;
      try {
        if (!id) {
          await setCurrentWorkOrder({});
        } else if (id !== currentWorkOrder?._id) {
          await fetchWorkOrderById(id);
        }

        const newTemplatesList = await getTemplatesList();
        if (isMountedRef.current) {
          setTemplates(newTemplatesList);
          setIsLoading(false);
        }
      } catch {
        if (isMountedRef.current) {
          setIsLoading(false);
        }
      }
    };

    init();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const changeSelectedTemplate = async select => {
    setIsLoading(true);
    setSelectedTemplate(select);
    try {
      if (!select) {
        await setCurrentTemplate({});
      } else {
        await fetchWorkOrderTemplateById(select.value);
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  };

    useEffect(() => {
        if (!isLoading) {
            setTimeout(() => window.scrollTo(0, 0), 0);
        }
    }, [isLoading]);

  // eslint-disable-next-line consistent-return
  const handlerSelectTemplate = select => {
    if (!isFormTouched) return changeSelectedTemplate(select);
    toggleModal(
      true,
      'confirmModal',
      true,
      {
        onAccept: () => changeSelectedTemplate(select),
        header: 'Are you sure (all fields will be rewrite)?',
        buttonLabels: { reject: 'Cancel' },
      },
    );
  };

  return (
    <div className="content content--work-order-template">
      <PageHeader isLoading={isLoading} WIN={!isLoading && currentWorkOrder?.WIN} />
      {
        !match?.params?.id
          ? (
            <div className="create_fields">
              <div className="fields_group">
                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="use_template">Use Template</label>
                  </div>
                  <div className="field_block">
                    <CustomSelect
                      isClearable
                      id="use_template"
                      options={templates}
                      value={selectedTemplate}
                      onChange={handlerSelectTemplate}
                      placeholder="Select Template"
                    />
                  </div>
                </div>
              </div>
            </div>
          )
          : (
            currentWorkOrder?.templateId
              ? (
                <div
                  title="Create using template"
                  className="blue-grey-text font-size-08 text-in-one-line padding-left-12-5 padding-bottom-10"
                >
                  {`Template${currentWorkOrder?.templateInfo?.name
                    ? ` "${currentWorkOrder?.templateInfo?.name}"`
                    : ''
                  } Used`}
                </div>
              )
              : null
          )
      }
      {
        isLoading
          ? (
            <div className="flex-box flex-center">
              <Loader />
            </div>
          )
          : (
            <CreateWorkOrderReduxForm onSubmit={onSubmit} setTouched={setFormTouched} />
          )
      }
    </div>
  );
};

const mapDispatchToProps = {
  getAccountBalanceByClient,
  fetchWorkOrderById,
  setCurrentWorkOrder,
  setCurrentTemplate,
  fetchWorkOrderTemplateById,
  toggleModal,
};

const mapStateToProps = state => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateAndEditWorkOrder));
